module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("To my three darling sisters:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Lols, Megs and Sammy-Lamb.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("and my amazing Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Thank you for all the love, laughter and not to forget, the drama!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What family is complete without it?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d58dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm01.vue
// module id = 63
// module chunks = 0